<template>
	<main v-if="isAuth" class="cart-page">
		<div class="cart-page__inner _cnt">
			<div class="cart-page__top">
				<div class="cart-page__top-title _h2">{{ $t('Checkout') }}</div>
			</div>
			<div v-if="cartContents.length" class="cart-page__body">
				<div class="cart-page__content">
					<div class="cart-page__list">
						<div
							class="cart-page__item"
							v-for="(item, i) in cartContents"
							:key="i"
						>
							<div class="cart-page__wrapper">
								<div class="cart-page__bg _ibg">
									<img src="@/assets/images/bg/yellow-blur.png" />
								</div>
								<div class="cart-page__image _ibg-contain">
									<img :src="getImageUrl(item)" />
								</div>
							</div>
							<div class="cart-page__about">
								<div class="cart-page__about-top">
									<div class="cart-page__about-name">
										{{ getSkinName(item.item.title) }}
									</div>
									<div class="cart-page__about-wear">
										({{ getWear(item.item.title) }})
									</div>
								</div>
								<div class="cart-page__about-type">
									{{ item.item.quality }}
								</div>
							</div>
							<div class="cart-page__price">
								<div class="cart-page__coin">
									<div class="cart-page__coin-number">
										{{ item.item.price.toFixed(2) }}
										{{ currencySymbol }}
									</div>
									<!--<div class="cart-page__coin-icon _ibg-contain">
										<img src="@/assets/images/icons/coin.svg" />
									</div>-->
								</div>
								<!--<div class="cart-page__real">
									<div class="cart-page__real-number">
										{{ item.item.price.toFixed(2) }}
									</div>
									<div class="cart-page__real-symbol">
										{{ currencySymbol }}
									</div>
								</div>-->
							</div>
							<button
								class="cart-page__delete"
								@click="handleDelete(item)"
							>
								<svg
									width="16"
									height="20"
									viewBox="0 0 16 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M9.71973 0C10.1174 0 10.499 0.158368 10.7803 0.439453C11.0615 0.720657 11.2196 1.10233 11.2197 1.5V2H15.4004C15.5329 2.0001 15.6602 2.05282 15.7539 2.14648C15.8476 2.24015 15.9003 2.36755 15.9004 2.5C15.9004 2.63242 15.8474 2.75979 15.7539 2.85352C15.6602 2.94719 15.5329 2.9999 15.4004 3H14.6797L14.2598 17.4502C14.2433 18.1014 13.9729 18.7207 13.5059 19.1748C13.0386 19.629 12.4114 19.8829 11.7598 19.8809H4.13965C3.48815 19.8828 2.86171 19.6289 2.39453 19.1748C1.92738 18.7206 1.65611 18.1015 1.63965 17.4502L1.21973 3H0.5C0.367392 3 0.240253 2.94728 0.146484 2.85352C0.0528497 2.75977 0 2.63251 0 2.5C0.000113018 2.36755 0.0528169 2.24015 0.146484 2.14648C0.240232 2.05285 0.367493 2 0.5 2H4.67969V1.5C4.6798 1.10233 4.83794 0.720657 5.11914 0.439453C5.40037 0.158258 5.782 8.25362e-05 6.17969 0H9.71973ZM11.0752 5.51758C10.9426 5.51758 10.8154 5.57029 10.7217 5.66406C10.6279 5.75783 10.5752 5.885 10.5752 6.01758L10.3252 16.0176C10.3252 16.1501 10.3779 16.2774 10.4717 16.3711C10.5654 16.4648 10.6926 16.5176 10.8252 16.5176C10.9578 16.5176 11.0849 16.4648 11.1787 16.3711C11.2725 16.2774 11.3252 16.1501 11.3252 16.0176L11.5752 6.01758C11.5752 5.885 11.5224 5.75783 11.4287 5.66406C11.3349 5.57029 11.2078 5.51758 11.0752 5.51758ZM4.8252 5.51074C4.69259 5.51074 4.56545 5.56346 4.47168 5.65723C4.378 5.75098 4.3252 5.8782 4.3252 6.01074L4.5752 16.0107C4.57527 16.1433 4.62798 16.2706 4.72168 16.3643C4.81543 16.4579 4.94265 16.5107 5.0752 16.5107C5.20774 16.5107 5.33496 16.4579 5.42871 16.3643C5.52241 16.2706 5.57512 16.1433 5.5752 16.0107L5.3252 6.01074C5.3252 5.8782 5.27239 5.75098 5.17871 5.65723C5.08494 5.56346 4.9578 5.51074 4.8252 5.51074ZM6.17969 1C6.04722 1.00008 5.91986 1.05283 5.82617 1.14648C5.7325 1.24015 5.6798 1.36755 5.67969 1.5V2H10.2197V1.5C10.2196 1.36755 10.1669 1.24015 10.0732 1.14648C9.97951 1.05294 9.85217 1 9.71973 1H6.17969Z"
									/>
								</svg>
							</button>
						</div>
					</div>
				</div>
				<div class="cart-page__info info">
					<div class="info__item">
						<div class="info__title _md">
							{{ $t('Contact information') }}
						</div>
						<div class="info__items">
							<BaseInput
								v-model="name"
								type="text"
								:label="`${$t('First name')}:`"
								class="info__input"
							/>
							<BaseInput
								v-model="surname"
								type="text"
								:label="`${$t('Last Name')}:`"
								class="info__input"
							/>
							<BaseInput
								v-model="email"
								type="email"
								:label="`${$t('Email')}:`"
								class="info__input"
							/>
							<BaseInput
								class="info__input"
								v-model="phone"
								type="text"
								:label="`${$t('Phone number')}:`"
							/>
						</div>
					</div>
					<div class="info__item">
						<div class="info__title _md">
							{{ $t('Steam trade link') }}
						</div>
						<BaseInput
							type="text"
							v-model="steamTradeLink"
							class="info__input"
							:label="`${$t('Steam trade link')}:`"
						/>
					</div>
					<div class="info__item">
						<div class="info__title _md3">
							{{ $t('Payment information') }}
						</div>
						<div class="info__items">
							<div class="info__input">
								<div class="info__select-label _select-label-input">
									{{ `${$t('Country')}:` }}
								</div>
								<select
									class="info__select _select-input"
									v-model="countryId"
								>
									<option
										v-for="option in countryOptions"
										:key="option.id"
										:value="option.id"
									>
										{{ option.title }}
									</option>
								</select>
							</div>
							<BaseInput
								v-model="city"
								type="text"
								:label="`${$t('City')}:`"
								class="info__input"
							/>
							<BaseInput
								v-model="address"
								type="text"
								:label="`${$t('Address')}:`"
								class="info__input"
							/>
							<BaseInput
								v-model="zip"
								type="text"
								:label="`${$t('Post Code')}:`"
								class="info__input"
							/>
						</div>
						<BaseTermCheckbox v-model="terms" class="info__checkbox">
							{{ $t('I agree with') }}
							<router-link
								v-if="termsPage?.slug"
								:to="{
									name: 'TextPage',
									params: { slug: termsPage.slug },
								}"
								class="desc small"
								target="_blank"
							>
								{{ termsPage.title }}
							</router-link>
							<template v-if="termsPage?.slug && privacyPage?.slug">
								<span class="desc small">{{ ' ' + 'and' + ' ' }}</span>
								<router-link
									:to="{
										name: 'TextPage',
										params: { slug: privacyPage.slug },
									}"
									class="desc small"
									target="_blank"
								>
									{{ privacyPage.title }}
								</router-link>
							</template>
						</BaseTermCheckbox>
					</div>
					<div class="info__inner">
						<div class="info__total total">
							<div class="total__top">
								<div class="total__column">
									<div class="total__text _md">
										{{ $t('Total to pay') }}:
									</div>
								</div>
								<div class="total__column">
									<div class="total__coin">
										<div class="total__coin-number">
											{{ totalAmount.toFixed(2) }}
											{{ currencySymbol }}
										</div>
										<!--<div class="total__coin-icon _ibg-contain">
											<img src="@/assets/images/icons/coin.svg" />
										</div>-->
									</div>
								</div>
							</div>
							<!--<div class="total__real">
								<div class="total__real-number">
									{{ totalAmount.toFixed(2) }}
								</div>
								<div class="total__real-symbol">
									{{ currencySymbol }}
								</div>
							</div>-->
						</div>
						<Transition>
							<div class="info__error" v-if="error">{{ error }}</div>
						</Transition>
						<div class="info__actions">
							<BaseButton
								class="info__submit _button-white"
								:loading="loaderIsVisible"
								:disabled="!requiredFieldsAreFilled || isSubmitting"
								@click="submitDeposit"
							>
								<span v-if="isSubmitting"
									>{{ $t('Submiting') }}...</span
								>
								<div v-else class="info__submit-image _ibg-contain">
									<img
										src="@/assets/images/icons/card-pay-image.svg"
									/>
								</div>
							</BaseButton>
							<BaseButton
								v-if="userBalance >= totalAmount"
								class="info__submit _button-white"
								@click="handleBuyButton"
								:disabled="
									cartContents?.length < 1 ||
									userBalance < totalAmount ||
									!requiredFieldsAreFilled
								"
							>
								<span>{{ $t('Balance') }}</span>
								<span>{{ currencySymbol }}</span>
								<!--<div class="info__submit-icon _ibg-contain">
									<img src="@/assets/images/icons/coin.svg" />
								</div>-->
							</BaseButton>
						</div>
					</div>
				</div>
			</div>
			<div class="cart-page__empty _md" v-if="!cartContents.length">
				{{ $t(`Cart is empty!`) }}
			</div>
		</div>
	</main>
</template>

<script>
import BaseButton from '@/components/base/BaseButton.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseTermCheckbox from '@/components/base/BaseTermCheckbox.vue';
import { PRIVACY_PAGE, TERMS_PAGE } from '@/store/modules/staticPages';
import { mapActions, mapGetters } from 'vuex';
export default {
	components: { BaseButton, BaseInput, BaseTermCheckbox },
	props: {
		isAuth: {
			type: Boolean,
			required: true,
		},
		cartContents: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			name: '',
			surname: '',
			email: '',
			phone: '',
			countryCode: '',
			phoneFull: '',
			countryOptions: [],
			countryOptionsIso: [],
			address: '',
			city: '',
			zip: '',
			countryId: '',
			error: '',
			terms: false,
			isSubmitting: false,
			steamTradeLink: '',
			imgDomain: process.env.VUE_APP_STATIC_DOMAIN,
		};
	},
	watch: {},
	mounted() {
		//this.steamId = this.userData.steamId;
		this.isSubmitting = false;
		this.getCountries();
		this.initializeUserData();
		this.fetchSteamTradeLink();
	},
	computed: {
		...mapGetters('user', ['userData']),
		...mapGetters('user', ['userBalance']),
		...mapGetters('modals', ['cartDropdownIsVisible']),
		...mapGetters('app', ['currencySymbol', 'currencyCode']),
		...mapGetters('staticPages', ['getTermsPage', 'getPrivacyPage']),
		termsPage() {
			return this.getTermsPage;
		},
		privacyPage() {
			return this.getPrivacyPage;
		},
		requiredFieldsAreFilled() {
			return (
				this.name &&
				this.surname &&
				this.phone &&
				this.email &&
				this.countryId &&
				this.city &&
				this.address &&
				this.zip &&
				this.steamTradeLink &&
				this.terms
			);
		},

		// ...mapGetters("cart", ["cartContents"]),
		//currencySymbol() {
		//	return this.$store.getters['app/currencySymbol'];
		//},
		// totalAmount() {
		//   return this.cartContents
		//     .reduce((total, item) => total + parseFloat(item.item.price), 0)
		//     .toFixed(2);
		// },
		totalAmount() {
			const sum = this.cartContents.reduce((total, item) => {
				const price = Number(item?.item?.price) || 0;
				const count = Number(item?.count) || 1;
				return total + price * count;
			}, 0);
			return Number(sum.toFixed(2));
		},
	},
	created() {
		this.TERMS_PAGE = TERMS_PAGE;
		this.PRIVACY_PAGE = PRIVACY_PAGE;
	},
	methods: {
		...mapActions('user', ['fetchUserData']),
		initializeUserData() {
			console.log('this.userData', this.userData);

			if (this.userData) {
				const isPlaceholder = (value, placeholder) =>
					value?.trim() === placeholder;

				this.email = this.userData.email;

				this.name = isPlaceholder(this.userData.name, 'Name')
					? ''
					: this.userData.name;

				this.surname = isPlaceholder(this.userData.surname, 'Surname')
					? ''
					: this.userData.surname;

				this.phone = this.userData.phone;
				this.address = this.userData.address;
				this.city = this.userData.city;
				this.zip = this.userData.zip;
				this.countryId = this.userData.country;
			}
		},
		phoneDataUpdate(e) {
			this.phoneFull = e.phoneNumber;
		},
		async fetchSteamTradeLink() {
			try {
				const response = await this.$http.get(
					process.env.VUE_APP_API + 'user/profile'
				);
				this.steamTradeLink = response.data.steam_trade_link || '';
			} catch (error) {
				console.error('Error fetching profile:', error);
			}
		},
		async getCountries() {
			try {
				const response = await this.$http.get(
					`${process.env.VUE_APP_API}countries`
				);
				this.countryOptions = response.data.payload;
				this.countryOptionsIso = response.data.payload.map(
					(obj) => obj.iso
				);
				this.countryCode = this.countryOptionsIso[0];
			} catch (error) {
				console.error('Failed to fetch countries:', error);
			}
		},
		async submitDeposit() {
			if (!this.requiredFieldsAreFilled) return;
			this.isSubmitting = true;
			const depositData = {
				name: this.name,
				surname: this.surname,
				email: this.email,
				phone: this.phone,
				country: this.countryId,
				city: this.city,
				address: this.address,
				postCode: this.zip,
				amount: this.totalAmount,
				paymentType: this.paymentType,
				currency: this.currencyCode,
				steam_trade_link: this.steamTradeLink,
			};

			try {
				const response = await this.$http.post(
					`${process.env.VUE_APP_API}deposit/checkout`,
					depositData
				);

				this.fetchUserData();

				if (response.data.status === 'ERROR') {
					this.$toast.error(this.$t(response.data.message));
					this.$router.push({ name: 'PaymentFailPage' });
					//this.closeDepositModal();
					this.isSubmitting = false;
				} else {
					window.location = response.data.redirect_url;
					//this.closeDepositModal();
					this.isSubmitting = false;
				}
			} catch (error) {
				console.log(error);
				this.$toast.error(this.$t(error.response.data.message));
				this.isSubmitting = false;
			}
		},
		back() {
			this.$router.go(-1);
		},
		getImageUrl(item) {
			if (item.item.item_type == 'pack') {
				return item.item.img_url;
			} else {
				return this.imgDomain + item.item.img_url;
			}
		},
		goToBalance() {
			this.closeCartDropdown();
			this.$router.push({ path: '/profile/balance' });
		},
		// ...mapActions('modals', ['closeCartDropdown']),
		...mapActions('cart', ['removeFromCart', 'fetchCartItems', 'clearCart']),
		...mapActions('user', ['fetchUserData']),
		closeCartDropdown() {
			this.$emit('close');
		},
		handleClearCart() {
			this.clearCart();
		},
		handleBuyButton() {
			this.isSubmitting = true;
			let data = {};

			this.$http
				.post(process.env.VUE_APP_API + 'purchase/product', { data })
				.then((res) => {
					if (res.data.status == 'OK') {
						this.closeCartDropdown();
						this.fetchCartItems();
						this.fetchUserData();
						this.$toast.success(this.$t('Purchase confirmed. Thanks'));
						this.$router.push({ path: '/profile/order-history' });
						this.isSubmitting = false;
					} else {
						this.$toast.warning(this.$t(res.data?.message));
						this.isSubmitting = false;
					}
				})
				.catch((res) => {
					this.$toast.error(this.$t(res.response?.data?.message));
					this.isSubmitting = false;
				});
		},
		removeOneFromCart(item) {
			this.$emit('removeOneFromCart', { ...item, id: item.item_id });
		},
		addToCart(item) {
			this.$emit('addToCart', { ...item, id: item.item_id });
		},
		onCountInput(item, raw) {
			const next = Math.max(1, Number(raw) || 1);
			this.$emit('setItemCount', { ...item, id: item.item_id, count: next });
		},
		getSkinName(title) {
			if (!title) return '';
			const match = title.match(/\|\s*([^()]+?)(?:\(|$)/);
			return match ? match[1].trim() : title;
		},

		getWear(title) {
			if (!title) return '';
			const match = title.match(/\(([^)]+)\)/);
			return match ? match[1].trim() : '';
		},
		async handleDelete(item) {
			try {
				await this.removeFromCart({ id: item.item_id });

				if (this.fetchCartItems) await this.fetchCartItems();
				this.$toast?.success?.(this.$t('Item removed from cart'));
			} catch (err) {
				this.$toast?.error?.(this.$t('Failed to remove item'));
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.cart-page {
	@include adaptiveValue('padding-top', 50, 20);
	@include adaptiveValue('padding-bottom', 50, 20);
	position: relative;
	&::before {
		content: '';
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-image: url('@/assets/images/bg/vertical-bg.png');
		background-repeat: no-repeat;
		background-size: contain;
		background-size: 100% 100%;
		z-index: -1;
	}
	&__inner {
	}
	&__top {
		display: flex;
		justify-content: center;
		gap: 6px;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 40, 15);
		}
		&-title {
			@include adaptiveValue('font-size', 32, 22);
		}
	}
	&__body {
		@media (min-width: $md2) {
			display: flex;
			justify-content: space-between;
			@include adaptiveValue('gap', 140, 20, 1470, 992, 1);
		}
	}
	&__content {
		@media (min-width: $md2) {
			flex: 0 1 100%;
			max-width: 710px;
		}
		@media (max-width: $md2) {
			&:not(:last-child) {
				margin-bottom: 25px;
			}
		}
	}
	&__info {
		@media (min-width: $md2) {
			flex: 0 1 100%;
			max-width: 588px;
		}
	}
	&__list {
	}
	&__item {
		gap: 24px;
		display: flex;
		border-radius: var(--border-radius-primary);
		border: 1px solid rgba(255, 255, 255, 0.1);
		background-color: var(--bg-card-color);
		padding-top: 10px;
		@include adaptiveValue('padding-right', 30, 10, 1470, 768, 1);
		padding-bottom: 10px;
		@include adaptiveValue('padding-left', 30, 10, 1470, 768, 1);
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 15, 6);
		}
		@media (max-width: $md4) {
			flex-wrap: wrap;
			gap: 20px;
		}
	}
	&__wrapper {
		position: relative;
	}
	&__bg {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		z-index: -1;
	}
	&__image {
		min-width: 108px;
		height: 80px;
	}
	&__about {
		flex: 1 1 auto;
		align-self: center;
		@media (max-width: $md4) {
			flex: 1 1 calc(100% - 128px);
		}
		&-top {
			display: flex;
			flex-wrap: wrap;
			gap: 6px;
			&:not(:last-child) {
				margin-bottom: 8px;
			}
		}
		&-name,
		&-wear {
			white-space: nowrap;
			font-size: 16px;
			font-family: var(--font-family-inter);
			line-height: 150%;
		}
		&-name {
			color: var(--primary-color);
			font-weight: 700;
		}
		&-wear {
			color: var(--secondary-color);
			font-weight: 500;
		}
		&-type {
			color: var(--secondary-color);
			font-weight: 500;
			font-size: 12px;
			line-height: 150%;
		}
	}
	&__price {
		align-self: center;
		@media (max-width: $md4) {
			flex: 1 1 calc(100% - 70px);
		}
	}
	&__coin {
		display: flex;
		align-items: center;
		@include adaptiveValue('gap', 8, 6);
		&-number {
			font-size: 18px;
			font-weight: 700;
			font-family: var(--font-family-inter);
			line-height: 150%;
		}
		&-icon {
			min-width: 15px;
			height: 15px;
		}
	}
	&__real {
		display: flex;
		gap: 3px;
		@media (min-width: $md4) {
			justify-content: flex-end;
		}
		&-number,
		&-symbol {
			color: var(--secondary-color);
			font-size: 12px;
			line-height: 150%;
			font-weight: 500;
		}
	}
	&__delete {
		background-color: transparent;
		min-width: 50px;
		position: relative;
		@media (any-hover: hover) {
			&:hover {
				svg {
					path {
						fill: var(--primary-color);
					}
				}
			}
		}
		svg {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			min-width: 24px;
			height: 24px;
			path {
				fill: var(--error-color);
				transition: fill 0.3s ease 0s;
			}
		}
	}
	&__empty {
		display: block;
		text-align: center;
		color: var(--secondary-color);
		text-transform: capitalize;
		@include adaptiveValue('margin-top', 40, 20);
	}
}

.info {
	&__item {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 35, 25);
		}
	}
	&__title {
		text-transform: capitalize;
		font-family: var(--font-family-inter);
		line-height: 120%;
		font-weight: 500;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 20, 15);
		}
	}
	&__items {
		@media (min-width: $md5) {
			display: flex;
			flex-wrap: wrap;
			column-gap: 20px;
			@include adaptiveValue('row-gap', 16, 8);
			.info__input {
				flex: 0 1 calc(50% - 10px);
			}
		}
	}
	&__input {
		@media (max-width: $md5) {
			&:not(:last-child) {
				margin-bottom: 10px;
			}
		}
	}
	&__select-label {
	}
	&__select {
	}
	&__checkbox {
		@include adaptiveValue('margin-top', 35, 18);
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 35, 18);
		}
	}
	&__inner {
	}
	&__total {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 55, 25);
		}
	}
	&__error {
	}
	&__actions {
	}
	&__submit {
		@include adaptiveValue('min-height', 46, 40);
		width: 100%;
		display: flex;
		align-items: center;
		gap: 4px;
		text-transform: capitalize;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 15, 6);
		}
		&-image {
			min-width: 103px;
			height: 33px;
		}
		&-icon {
			min-width: 20px;
			height: 20px;
		}
	}
}

.total {
	&__top {
		display: flex;
		gap: 20px;
		justify-content: space-between;
	}
	&__column {
	}
	&__text {
		font-family: var(--font-family-inter);
		font-weight: 700;
		line-height: 150%;
		color: var(--primary-color);
		text-transform: capitalize;
	}
	&__coin {
		display: flex;
		align-items: center;
		@include adaptiveValue('gap', 8, 6);
		&-number {
			@include adaptiveValue('font-size', 24, 18);
			font-weight: 700;
			font-family: var(--font-family-inter);
			line-height: 150%;
		}
		&-icon {
			@include adaptiveValue('min-width', 20, 15);
			@include adaptiveValue('height', 20, 15);
		}
	}
	&__real {
		display: flex;
		gap: 3px;
		justify-content: flex-end;
		&-number,
		&-symbol {
			color: var(--secondary-color);
			font-size: 12px;
			line-height: 150%;
			font-weight: 500;
		}
	}
}
</style>
